import { Model } from "@ofqual/portal-core/core/types";

export type BusinessModel = {
  id: string;
  title: string;
  value: string;
};

export const fromApiModel = (model: Model): BusinessModel => {
  return {
    id: model.id,
    title: model.title,
    value: model.value,
  };
};

export const toApiModel = (item: BusinessModel): Model => {
  return {
    ...item,
  } as Model;
};
